{
  "backButton": "Повернутися до {prevMenuButton}",
  "moreActions": "Більше дій",
  "unavailable": "Недоступно, розгорніть для докладнішої інформації"
}
